module.exports = __webpack_public_path__ + "/img/Oscillator-Corner-Concave-WUyyKm.svg";